import api from "../store/services/api";

export const getAIAgents = () => api.get("/agents/");

export const createAIAgent = (data) =>
  api.post("/agents/", data, {
    headers: { "Content-Type": "application/json" },
  });

export const updateAIAgent = (agentId, data) =>
  api.put(`/agents/?id=${agentId}`, data, {
    headers: { "Content-Type": "application/json" },
  });

export const deleteAIAgent = (agentId) =>
  api.delete(`/agents/?id=${agentId}`);

export const getAIAgentTools = () => api.get("/agents/tools/");

const AIAgentService = {
  getAIAgents,
  createAIAgent,
  updateAIAgent,
  deleteAIAgent,
  getAIAgentTools,
};

export default AIAgentService;
